import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=002c49bd&"
import script from "./Settlements.vue?vue&type=script&lang=ts&"
export * from "./Settlements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports